import request from '@/utils/request'

// 获取登录用户的基本信息
export const getUserCustomerAPI = data => {
  return request.get('/user/query', {
    headers: {
      token: data
    }
  })
}

// 根据用户名登录
export const loginNameAPI = data => {
  return request.post('/user/login/name', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 根据手机号登录
export const loginPhoneAPI = data => {
  return request.post('/user/login/phone', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 登录的API接口
export const registerAPI = data => {
  return request.post('/user/register', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 登录的API接口
export const findPasswordAPI = data => {
  return request.post('/user/findpassword', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 修改用户信息的 API（形参中的 obj 是对象格式的信息）
export const updateUserCustomerAPI = (obj, data) => {
  return request.post('/user/update', obj, {
    headers: {
      token: data,
      'Content-Type': 'application/json'
    }
  })
}

// 用户注销
export const killUserAPI = (data) => {
  return request.post('/user/killuser', data, {
    headers: {
      token: data,
      'Content-Type': 'application/json'
    }
  })
}
